import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "@/lib/links";

const off = { enabled: false, url: "" };
const initial = { windows: off, mac: off, plans: { trial: true, monthly: true, yearly: true } };

export const isLive = (p) => Boolean(p?.enabled && p?.url);

export const useDownloads = () => {
  const [downloads, setDownloads] = useState(initial);
  useEffect(() => {
    axios.get(`${API_URL}/downloads`).then(({ data }) => setDownloads(data)).catch(() => {});
  }, []);
  return downloads;
};
